import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import PropTypes from "prop-types";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Description from "@mui/icons-material/Description";

// core components
import Grid from "@mui/material/Grid";

import { } from "../othelloConstantes.jsx";
import OthelloEdit from "../componentsothello/OthelloEdit.jsx";
import OthelloTimer from "../componentsothello/OthelloTimer.jsx";
import Button from "../components/Button.jsx";

import MDBox from "../components/MDBox/index.js";
import MDTypography from "../components/MDTypography/index.js";
import { Paper } from '@mui/material';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Alert } from '@mui/material';

import { EstadoReserva, ResultadoReserva, PopUpResult } from "../othelloConstantes.jsx";
import { getBotonPagarPasarelaPago } from "../othelloFunciones.jsx";



export default function TicketReservaInfo({ ...props }) {

    const { reserva, infouso, modoexterno, id_Rol, desdeticketreserva } = props;

    const[infopago, setinfopago] = React.useState(null);
   
    const GetLinkPagoReserva = () =>
    {
        var jsonData = JSON.stringify({ id_oficina: reserva.id_Oficina, localizador: reserva.localizador, modoexterno: modoexterno, desdeticketreserva: desdeticketreserva });

        fetch('api/Data/GetLinkPagoReserva',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res != null && res.ok) {

                    if (res.resultado == ResultadoReserva.OkAFaltaDePago) {
                        setinfopago(res.infopago);
                    }
                    else {
                        // setalert(PopUpResult.OK);
                        //setLoading(false);                    
                        setinfopago(null);
                    }
                }
                else {
                    //    setalert(PopUpResult.KO);
                }                

            }).catch(error => {
                //setalert(PopUpResult.KO);                
            });
    }


    function renderSecciones(texto) {

        return <MDBox
            sx={{
                position: 'sticky',
                bottom: 0,
                width: '100%',
              //  backgroundColor: '#f9fafb',
              //  borderTop: '1px solid #e0e0e0',
               // boxShadow: '0 -2px 12px rgba(0, 0, 0, 0.06)',
                py: 1,
                px: { xs: 1, sm: 1, md: 1 },
                display: 'flex',
                alignItems: 'stretch',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                zIndex: 1100,
                gap: 2,
            }}
        >
            {/* Secci�n destacada */}
            <Paper
                elevation={0}
                sx={{
                    border: '1px solid #1976d2',
                    borderRadius: 1,
                    backgroundColor: '#ffffff',
                    px: 2,
                    py:1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 3,
                    flex: {
                        xs: '1 1 100%', // Pantallas peque�as: 100%                        
                        md: '1 1 85%',  // A partir de md: 75%
                    },
                    flexWrap: 'wrap',
                    minWidth: 0,
                }}
            >
                <MDBox>
                    <MDTypography variant="subtitle" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                        {texto}
                    </MDTypography>                     
                </MDBox>                
            </Paper>            
        </MDBox> 
    }

    function TratarTexto(infoshow)
    {
        if (!infoshow) return "";

        return (
            <MDBox
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    backgroundColor: '#f9fafb',
                    border: '1px solid #e5e7eb',
                    borderRadius: 2,
                    padding: 2,
                    mt: 1,
                    mb: 1,
                    mx: 1
                }}
            >
                <InfoOutlinedIcon sx={{ color: '#0ea5e9', mr: 1, mt: 0.5 }} />
                <MDTypography
                    variant="body2"
                    sx={{
                        color: '#374151',
                        lineHeight: 1.6,
                        whiteSpace: 'pre-line', // esto interpreta \n como saltos de l�nea
                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: infoshow }} />
                </MDTypography>
            </MDBox>
        );
    }

    function renderTicketReserva(item) {

        if (item != null)
        {
            if (item != null) {

                let extras = "";

                if (item.dataExtrasResult != null && item.dataExtrasResult.length > 0) {
                    let resextras = item.dataExtrasResult.map(x =>
                        <Grid container>                            
                            {x.concepto != null && x.concepto != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="Extra" currentvalue={x.concepto} readonly={true} />
                                </Grid> : ""
                            }
                            {x.cantidad != null && x.cantidad != "" ?
                                <Grid item xs={2} sm={2} >
                                    <OthelloEdit variant="outlined" label="Cantidad" currentvalue={x.cantidad} readonly={true} />
                                </Grid> : ""
                            }
                            {x.precio != null && x.precio != "" ?
                                <Grid item xs={2} sm={2} >
                                    <OthelloEdit variant="outlined" label="Precio" currentvalue={x.precio} readonly={true} />
                                </Grid> : ""
                            }
                            {x.total != null && x.total != "" ?
                                <Grid item xs={2} sm={2} >
                                    <OthelloEdit variant="outlined" label="Total" currentvalue={x.total} readonly={true} />
                                </Grid> : ""
                            }
                        </Grid>
                    );

                    if (resextras != null && resextras != "") {
                        extras = (<>
                            {renderSecciones("Extras")}
                            <MDBox m={1}>                                   
                                {resextras}
                            </MDBox>
                        </>);
                    }
                }

                let nomiacion = "";

                if (item.dataNominacionResult != null && item.dataNominacionResult.length > 0) {
                    let resnomiacion = item.dataNominacionResult.map(x =>
                        <Grid container>
                            {x.cantidad != null && x.cantidad != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="Nombre" currentvalue={x.nombre} readonly={true} />
                                </Grid> : ""
                            }
                            {x.apellidos != null && x.apellidos != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="Apellidos" currentvalue={x.apellidos} readonly={true} />
                                </Grid> : ""
                            }
                            {x.dni != null && x.dni != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="D. Identidad" currentvalue={x.dni} readonly={true} />
                                </Grid> : ""
                            }
                            {x.sexo != null && x.sexo != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="Sexo" currentvalue={x.sexo} readonly={true} />
                                </Grid> : ""
                            }
                            {x.edad != null && x.edad != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="Edad" currentvalue={x.edad} readonly={true} />
                                </Grid> : ""
                            }
                            {x.fechaNacimiento != null && x.fechaNacimiento != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloTimer variant="outlined" label="Fecha de Nacimiento" currentvalue={x.fechaNacimiento} readonly={true} />
                                </Grid> : ""
                            }
                            {x.telefono != null && x.telefono != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="Telefono" currentvalue={x.telefono} readonly={true} />
                                </Grid> : ""
                            }
                            {x.email != null && x.email != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="Email" currentvalue={x.email} readonly={true} />
                                </Grid> : ""
                            }
                            {x.club != null && x.club != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="Club" currentvalue={x.club} readonly={true} />
                                </Grid> : ""
                            }
                            {x.direccion != null && x.direccion != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit variant="outlined" label="Direccion" currentvalue={x.direccion} readonly={true} />
                                </Grid> : ""
                            }
                            {x.codigoPostal != null && x.codigoPostal != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="Codigo Postal" currentvalue={x.codigoPostal} readonly={true} />
                                </Grid> : ""
                            }
                            {x.procedencia != null && x.procedencia != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit variant="outlined" label="Procedencia" currentvalue={x.procedencia} readonly={true} />
                                </Grid> : ""
                            }
                            {x.talla != null && x.talla != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit variant="outlined" label="Talla" currentvalue={x.talla} readonly={true} />
                                </Grid> : ""
                            }
                            {x.numRegistroSanitario != null && x.numRegistroSanitario != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit variant="outlined" label="N Registro Sanitario" currentvalue={x.numRegistroSanitario} readonly={true} />
                                </Grid> : ""
                            }
                            {x.curso != null && x.curso != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit variant="outlined" label="Curso" currentvalue={x.curso} readonly={true} />
                                </Grid> : ""
                            }
                            {x.madrugadores != null && x.madrugadores != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit variant="outlined" label="Madrugadores" currentvalue={x.madrugadores} readonly={true} />
                                </Grid> : ""
                            }
                            {x.sabeNadar != null && x.sabeNadar != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit variant="outlined" label="SabeNadar" currentvalue={x.sabeNadar} readonly={true} />
                                </Grid> : ""
                            }
                        </Grid>
                    );

                    if (resnomiacion != null && resnomiacion != "") {
                        nomiacion = (<>
                            {renderSecciones("Datos del Formulario")}
                            <MDBox m={1}>
                                {resnomiacion}
                            </MDBox>                           
                        </>);
                    }
                }

                let autorizacion = "";

                if (item.dataAutorizacionesDataResult != null) {
                    let respaxnomiacion = "";
                    let resautorizacion = <Grid container>
                        <Grid item xs={6}  >
                            <OthelloEdit variant="outlined" label="D/Dna" currentvalue={item.dataAutorizacionesDataResult.nombreApellidosAutoriza} readonly={true} />
                        </Grid>
                        <Grid item xs={6} >
                            <OthelloEdit variant="outlined" label="con Documento" currentvalue={item.dataAutorizacionesDataResult.dniAutoriza} readonly={true} />
                        </Grid>
                        <Grid item xs={6} >
                            <OthelloEdit variant="outlined" label="Telefono/s" currentvalue={item.dataAutorizacionesDataResult.telefonoAutoriza} readonly={true} />
                        </Grid>
                        <Grid item xs={6} >
                            <OthelloEdit variant="outlined" label="AUTORIZO como: " currentvalue={item.dataAutorizacionesDataResult.autorizoComo} readonly={true} />
                        </Grid>
                    </Grid>

                    if (item.dataAutorizacionesDataResult != null && item.dataAutorizacionesDataResult.paxautorizadas != null && item.dataAutorizacionesDataResult.paxautorizadas.length > 0) {
                        respaxnomiacion = item.dataAutorizacionesDataResult.paxautorizadas.map(x =>
                            <Grid container>
                                {x.nombreApellidos != null && x.nombreApellidos != "" ?
                                    <Grid item xs={6}>
                                        <OthelloEdit variant="outlined" label="Nombre" currentvalue={x.nombreApellidos} readonly={true} />
                                    </Grid> : ""
                                }
                                {x.dni != null && x.dni != "" ?
                                    <Grid item xs={6}>
                                        <OthelloEdit variant="outlined" label="D. Identidad" currentvalue={x.dni} readonly={true} />
                                    </Grid> : ""
                                }
                            </Grid>
                        );
                    }

                    if (resautorizacion != null && resautorizacion != "") {
                        autorizacion = (<>
                            {renderSecciones("Datos de Autorizaciones")}
                            <MDBox m={1}>
                                {resautorizacion}
                                {respaxnomiacion}
                            </MDBox>                             
                        </>);
                    }
                }

                let informacioncerraduras = "";

                if ((item.activaCerradura == 1 && item.iD_Cerradura != null && item.iD_Cerradura != "") ||
                    (item.idReservCerradura != null && item.idReservCerradura != "") || (item.linkCerradura != null && item.linkCerradura != "") || (item.codigoCerradura != null && item.codigoCerradura != ""))
                {
                    informacioncerraduras = <>
                        {renderSecciones("Datos de Acceso")}                             
                        <MDBox m={1}>                            
                            <Grid container>
                                <Grid item xs={6} >
                                    <OthelloEdit variant="outlined" label="ID Acceso" currentvalue={item.idReservCerradura} readonly={true} />
                                </Grid>
                                <Grid item xs={6} >
                                    <OthelloEdit variant="outlined" label="Codigo Acceso" currentvalue={item.codigoCerradura} readonly={true} />
                                </Grid>
                                <Grid item xs={12} >
                                    <OthelloEdit variant="outlined" label="Link Acceso" currentvalue={item.linkCerradura} readonly={true} rows={5} />
                                </Grid>
                            </Grid>
                        </MDBox></>
                }

                let informacionuso = "";

                if (infouso != null && infouso != "")
                {
                    informacionuso = TratarTexto(infouso)

                    // infoshow = infoshow.split("\n").map((i, key) => { return <div key={key}>{i}</div>; }); 
                    //let infoshow = ticket.infouso.replace("\n", "<br>")
                    //infoshow = <div dangerouslySetInnerHTML={{ __html: infoshow }} />;
                    //informacionuso = <><br/><hr /><Grid container><Grid item xs={12} mt={4} ml={0}><p style={{ fontSize: 14 }} ><b><center>{infoshow}</center></b></p></Grid></Grid></>;
                }        

                let FaltaPago = false;
                let textoFaltaPago = "";

                if (item.pagada == 0 || (item.pagada == 1 && item.ampliando == 1)) {
                    FaltaPago = true;

                    //Si no se pago la reserva
                    if (item.pagada == 0)
                        textoFaltaPago = item.precio + " Euros - A Falta de Pago";
                    else
                        textoFaltaPago = "Pagado "+ item.precio + " Euros - A Falta de Pago Ampliacion " + item.dataAmpliacionReservaResult.precio + " Euros";
                }
                else
                    textoFaltaPago = item.precio + " Euros - Pagada";

                return (<MDBox m={2} sx={{ backgroundColor : "white" }}>
                    {renderSecciones("Resumen de la Reserva")}        
                    <MDBox m={1}>
                        <Grid container>
                            <Grid item xs={6}  >
                                <OthelloEdit variant="outlined"  label="Reserva" currentvalue={item.localizador} readonly={true} />
                            </Grid>
                            <Grid item xs={6}  >
                                <OthelloEdit variant="outlined"  label="Actividad" currentvalue={item.instalacion} readonly={true} />
                            </Grid>
                            <Grid item xs={6}  >
                                <OthelloEdit variant="outlined" label="Fecha" currentvalue={item.fechastring} readonly={true} />
                            </Grid>
                            <Grid item xs={6}  >
                                <OthelloEdit variant="outlined"  label="Franja" currentvalue={item.tramo} readonly={true} />
                            </Grid>
                            <Grid item xs={6}  >
                                <OthelloEdit variant="outlined" label="Plazas" currentvalue={item.cantidad} readonly={true} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={6}  >
                                    <OthelloEdit variant="outlined" label="Alta Reserva" currentvalue={item.fechareservastring} readonly={true} />
                            </Grid>
                            <Grid item xs={6}  >
                                    <OthelloEdit variant="outlined" label="Estado Reserva" currentvalue={item.estado == EstadoReserva.Confirmada || item.estado == "Confirmada" ? "Confirmada" : "Anulada"} readonly={true} />
                            </Grid>
                        </Grid>
                        {item.fechafinalreservastring != null && item.fechafinalreservastring != "" ?
                            <Grid container>
                                <Grid item xs={6}  >
                                        <OthelloEdit variant="outlined" label="Inicio Reserva" currentvalue={item.fechainicioreservastring} readonly={true} />
                                </Grid>
                                <Grid item xs={6}  >
                                        <OthelloEdit variant="outlined" label="Final Reserva" currentvalue={item.fechafinalreservastring} readonly={true} />
                                </Grid>
                            </Grid> : ""
                        }
                        <Grid container>
                            <Grid item xs={12}  >
                                    <OthelloEdit variant="outlined" label="Indicaciones o comentarios" currentvalue={item.observaciones} rows={2} readonly={true} />
                            </Grid>
                        </Grid>
                    </MDBox>
                    {item.precio > 0 ?
                        <>
                            {renderSecciones("Precio Reserva")} 
                            <MDBox m={1}>
                                <Card variant="outlined" sx={{ backgroundColor: "#f9f9f9", px:1, mx:1 }} >
                                    <CardContent>                                    
                                            <MDTypography variant="h5" fontWeight="bold" gutterBottom mt={3}>
                                            {textoFaltaPago}
                                        </MDTypography>
                                        {FaltaPago ?
                                            (infopago != null ?
                                                getBotonPagarPasarelaPago(id_Rol, infopago, null )
                                                :
                                                <Button fullWidth variant="contained" color="primary" size="large" onClick={GetLinkPagoReserva} sx={{ marginTop: 15 }}>
                                                    Obtener Link Pago
                                                </Button> 
                                            ) : ""
                                        }
                                    </CardContent>
                                </Card>
                                <MDBox p={1} mt={2}>
                                    <Alert severity="warning" icon={false} sx={{ fontSize: "1.0rem" }}>
                                        Las reservas sin pagar seran canceladas automaticamente en el caso de no realizarse el pago. Las Ampliaciones no seran validas de no hacerse el pago de estas.
                                    </Alert>
                                </MDBox>
                                <Grid>
                                    <Grid item xs={12}  >
                                        <OthelloEdit variant="outlined" label="Informacion Adicional" currentvalue={item.infoAdicionalPlazasPrecios} rows={2} readonly={true} />
                                    </Grid>
                                </Grid>
                            </MDBox>      
                            </> : ""
                    }
                    {renderSecciones("Datos de Contacto")}                            
                    <MDBox m={1}>                        
                        <Grid container>
                            <Grid item xs={6} >
                                <OthelloEdit variant="outlined" label="Contacto" currentvalue={item.contacto} readonly={true} />
                            </Grid>
                            <Grid item xs={6} >
                                <OthelloEdit variant="outlined" label="E-Mail" currentvalue={item.eMail} readonly={true} />
                            </Grid>
                            <Grid item xs={6} >
                                <OthelloEdit variant="outlined" label="Telefono" currentvalue={item.telefono} readonly={true} />
                            </Grid>
                            <Grid item xs={6} >
                                <OthelloEdit variant="outlined" label="Dato Adicional" currentvalue={item.numSocio} readonly={true} />
                            </Grid>
                        </Grid>
                    </MDBox>
                    {informacioncerraduras}
                    {extras}
                    {nomiacion}
                    {autorizacion}
                    {informacionuso }
                </MDBox>);
            }
        }
        else
            return <p>No se pudo mostrar el ticket, intentelo mas tarde</p>
    }   


    let cargando = reserva == null ? <p><CircularProgress color="secondary" /></p> : "";       

    return (reserva == null ? cargando : renderTicketReserva(reserva)        );
}


TicketReservaInfo.propTypes =
{
    reserva: PropTypes.object
}